import React from "react";
import {makeStyles} from '@material-ui/core/styles';
import {Box, FormControlLabel,Typography} from "@material-ui/core";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles(theme => ({

  radioStyles: props => ({
    '& >div>label>span': {
      padding: theme.spacing(0.5, 0, 0, 1),
      fontSize: '0.9rem',
    },
  }),
  radioColors: props => ({
    '& >span:nth-child(2)': {
      color: '#000000'
    },
    '& .Mui-checked': {
      color: props.mainBg,
    },
    '& >span': {
      color: props.mainBg,
      '& >span>div>svg': {
        fontSize: '1.2rem',
      },
    },
    checked: {},
  })
}));

export default function MaterialUiRadio(props) {
  let propsDrawer = {...props.propsDrawer};
  const classes = useStyles(propsDrawer);

  return (
    <Box display='flex' alignItems='center'>
      {props.radiolabel !== undefined ?
        <Box fontWeight='fontWeightBold' mr={2}>
          <Typography variant='subtitle2'>
            {props.radiolabel}
          </Typography>
        </Box>
      : "" }
      {props.radioOptions.map((radioData) => (
        <FormControl component="fieldset" className={classes.radioStyles}>
          <RadioGroup aria-label="radioSet" value={props.radioValue} onChange={props.handleChangeRadio}>
            <FormControlLabel
              value={radioData.value}
              className={classes.radioColors}
              control={<Radio/>}
              label={radioData.label}
              disabled={radioData.disable}
              size="small"
            />
          </RadioGroup>
        </FormControl>
      ))}
    </Box>

  );
}
